import { useState, useEffect } from "react"
import { useContext } from "react"
import { APIContext } from "context/APIContext"

export default function WorkoutV5WeightRecommendationPreview({ 
    kinesisUserGroupId = null,
    userId = null,
    exerciseId,
    setUnitsAssigned,
    taper,
    taperDampener
}) {

    const { GetWeightRecommendation } = useContext(APIContext)

    const [weightRecommendationData, setWeightRecommendationData] = useState(null)

    const LoadWeightRecommendation = async () => {
        setWeightRecommendationData(null)
        const weightRecommendationData = await GetWeightRecommendation(kinesisUserGroupId, userId, exerciseId, setUnitsAssigned, taper, taperDampener, [], 1)
        setWeightRecommendationData(weightRecommendationData)
    }

    useEffect(() => { LoadWeightRecommendation() }, [])

    if (weightRecommendationData === null) {
        return (
            <div className='h-8 w-24 bg-gray-200 rounded animate-pulse' />
        )
    }

    return (
        <div className='w-full rounded-lg p-1'>
            <p>{weightRecommendationData.weightRecommendationRounded} lbs</p>
        </div>
    )
}